{
  "yes": "Yes",
  "no": "No",
  "optional": "(optional)",
  "cancel": "Cancel",
  "apply": "Apply",
  "back": "Back",
  "close": "Close",
  "now": "Now",
  "save": "Save",
  "breadcrumb": {
    "label": "Breadcrumb navigation",
    "home": "Home"
  },
  "dataGrid": {
    "head": {
      "selection": {
        "selectAll": "Select all rows",
        "deselectAll": "Deselect all rows",
        "select": "Add row with ID '{id}' to the selection.",
        "deselect": "Remove row with ID '{id}' from the selection."
      },
      "sorting": {
        "action": {
          "asc": "Sort the table ascending by the {field} column.",
          "desc": "Sort the table descending by the {field} column.",
          "none": "Reset sorting."
        },
        "menu": {
          "asc": "Sort ascending",
          "desc": "Sort descending",
          "none": "No sorting"
        }
      },
      "filtering": {
        "removeLabel": "Remove search term for column {column}",
        "menu": {
          "label": "Search column {column}",
          "placeholder": "Search column"
        }
      },
      "hideColumns": {
        "revealFlyout": "List of hidden columns",
        "revealTrigger": "Show hidden columns",
        "menu": {
          "hideButton": "Hide column",
          "lastColumnTooltip": "The last column cannot be hidden."
        }
      }
    },
    "editing": {
      "label": "{column} with ID {id}"
    },
    "loadMore": "Load more",
    "rowRearrange": {
      "rearrange": "Rearrange rows",
      "reset": "Reset changes",
      "dragToMove": "Drag to move row"
    }
  },
  "validations": {
    "tooShort": {
      "preview": "Too short, minimum {minLength} characters required",
      "fullError": "Make the input at least {minLength} characters long. It is currently {n} characters long. Special characters might use more than one character."
    },
    "tooLong": {
      "preview": "Too long, maximum {maxLength} characters allowed",
      "fullError": "Shorten the input to {maxLength} characters or less. It is currently {n} characters long. Special characters might use more than one character."
    },
    "rangeUnderflow": {
      "preview": "Too low",
      "fullError": "Input value must be greater than or equal to {min}."
    },
    "rangeOverflow": {
      "preview": "Too high",
      "fullError": "Input value must be less than or equal to {max}."
    },
    "patternMismatch": {
      "preview": "Invalid format",
      "fullError": "Please match the format requested."
    },
    "valueMissing": {
      "preview": "Required",
      "fullError": "The field is empty, it is mandatory and must be filled in."
    },
    "stepMismatch": {
      "preview": "Invalid number",
      "fullError": "Please enter a valid number, that is a multiple of {step}."
    },
    "badInput": {
      "preview": "Invalid input",
      "fullError": "\"{value}\" does not match the expected type."
    },
    "typeMismatch": {
      "generic": {
        "preview": "Invalid input type",
        "fullError": "\"{value}\" does not match the expected type."
      },
      "email": {
        "preview": "Invalid mail",
        "fullError": "\"{value}\" is not a valid email address. It should be similar to \"johndoe{'@'}example.com\" (Must contain one {'@'} symbol and a period)."
      },
      "number": {
        "preview": "Invalid number",
        "fullError": "\"{value}\" is not a valid number. Make sure it contains only digits, and optionally a single decimal point."
      },
      "tel": {
        "preview": "Invalid phone number",
        "fullError": "\"{value}\" is not a valid phone number."
      },
      "url": {
        "preview": "Invalid URL",
        "fullError": "\"{value}\" is not a valid URL. A URL usually points to a website and should be similar to \"https://www.example.com\"."
      }
    }
  },
  "select": {
    "toggleDropDown": "Toggle selection popover",
    "empty": "No data available",
    "noMatch": "No item matches your search",
    "searchInputLabel": "Filter the list items",
    "clearSearch": "Clear search filter",
    "searchPlaceholder": "Search"
  },
  "selections": {
    "selectAll": "Select all",
    "selectFiltered": "Select filtered",
    "selectGroup": "Selected",
    "currentSelection": "{n} selected"
  },
  "stepper": {
    "decrement": "Decrement by {stepSize}",
    "increment": "Increment by {stepSize}"
  },
  "table": {
    "empty": "This table is empty."
  },
  "link": {
    "opensExternally": "(opens in a new tab)"
  },
  "navItemOptionsLabel": "Subpages of {label}",
  "navigation": {
    "appLogo": "App logo of {appName}",
    "goToHome": "Go to home page",
    "goBack": "Go back",
    "moreNavItems": "+{n} More",
    "moreNavItemsLabel": "More Items",
    "showMoreNavItemsLabel": "Show more items",
    "userMenuLabel": "User options",
    "toggleBurgerMenu": "Toggle burger menu",
    "toggleContextMenu": "Toggle context menu",
    "navigationHeadline": "Navigation",
    "moreActionsFlyout": "Choose an action for the column \"{column}\"",
    "moreActionsTrigger": "Toggle column actions",
    "collapse": "Collapse",
    "expand": "Expand"
  },
  "tooltip": {
    "neutral": "Toggle info tooltip",
    "danger": "Toggle error tooltip",
    "success": "Toggle success tooltip"
  },
  "colorScheme": {
    "headline": "Change appearance",
    "subtitle": "Select the appearance of the application:",
    "appearance": "Appearance",
    "auto": {
      "label": "Auto",
      "description": "The application automatically adapts its appearance to your system settings."
    },
    "light": {
      "label": "Light",
      "description": "Light mode provides optimal contrast for bright environments."
    },
    "dark": {
      "label": "Dark",
      "description": "This color mode is optimized for darker environments."
    }
  },
  "pagination": {
    "label": "Pagination",
    "ofPages": "of {pages} page | of {pages} pages",
    "previous": "previous page",
    "next": "next page",
    "buttonLabel": "Page {page}",
    "morePages": "More pages in between",
    "select": {
      "label": "Page selection",
      "listLabel": "Available pages"
    },
    "currentOfTotalPages": "1/1 page | {current}/{total} pages"
  },
  "input": {
    "clear": "Clear input",
    "showPassword": "Show Password",
    "hidePassword": "Hide Password"
  },
  "dialog": {
    "close": "Close dialog"
  },
  "headline": {
    "copyLink": "Copy link to this headline",
    "copyLinkTo": "Copy link to headline:"
  },
  "avatar": {
    "ariaLabel": "Avatar of {fullName}"
  },
  "filterTag": {
    "clickToAdd": "Add filter \"{label}\"",
    "clickToRemove": "Remove filter \"{label}\""
  },
  "languageSelect": {
    "label": "Language",
    "headline": "Change language",
    "subtitle": "Select the language of the application:"
  },
  "resizeHandle": {
    "label": "Drag to change width"
  },
  "fileUpload": {
    "select": "Select",
    "clickToUpload": "Click to select",
    "orDragAndDrop": "or drag and drop file",
    "maxFileSize": "Maximum file size",
    "inTotal": "in total",
    "maxFileCount": "Maximum {n} files to select in total",
    "allowedFileTypes": "Allowed file types: {types}",
    "hideFilesButton": "Hide all files",
    "revealFilesButton": "Show all files",
    "removeFile": "Remove file",
    "requiredError": "You need to upload at least one file",
    "status": {
      "fileTypeError": "File with extension '.{extension}' is invalid",
      "fileSizeError": "File exceeds maximum allowed size of {size}",
      "maxFileSizeError": "Total size of all files exceeds maximum allowed of {size}",
      "maxCountError": "Number of files exceeds maximum allowed of {count}"
    }
  },
  "globalFAB": {
    "label": "Global actions"
  },
  "calendar": {
    "todayButton": {
      "label": "Today",
      "tooltip": "Jump to today"
    },
    "calendarWeek": "CW",
    "calendarWeekButtonLabel": "Select calendar week {weekNumber}",
    "previousMonthButton": "Previous month",
    "nextMonthButton": "Next month",
    "monthYearPicker": "Month and year picker"
  },
  "flyoutMenu": {
    "moreActions": "More actions",
    "toggleActions": {
      "click": "Click to toggle action visibility",
      "hover": "Hover/Focus to toggle action visibility"
    }
  },
  "slider": {
    "decreaseValueBy": "Decrease value by {n}",
    "increaseValueBy": "Increase value by {n}",
    "changeValue": "Change value",
    "changeStartValue": "Change start value",
    "changeEndValue": "Change end value"
  },
  "codeTabs": {
    "label": "Code snippets",
    "copySnippet": "Copy code",
    "copied": "Copied!",
    "failed": "Failed!",
    "tabLabel": "Code"
  },
  "search": {
    "label": "Search",
    "filterLabel": "Toggle filters",
    "selectFilter": "Select filters",
    "leadingShortcutPlaceholder": "Type",
    "trailingShortcutPlaceholder": "to search"
  },
  "globalSearch": {
    "label": "Global search",
    "searchResults": "Search results",
    "input": {
      "label": "Search for content",
      "placeholder": "Search..."
    },
    "shortcuts": {
      "move": "Navigate",
      "select": "Select"
    },
    "system": "System"
  },
  "timePicker": {
    "placeholder": {
      "hour": "HH",
      "minute": "MM",
      "second": "SS"
    },
    "labels": {
      "from": "from",
      "to": "to",
      "iconButton": "Open time picker",
      "popover": "Time picker",
      "hour": "Hour",
      "minute": "Minute",
      "second": "Second",
      "listLabel": "Time options",
      "am": "AM",
      "pm": "PM",
      "timeSuffix": "Select AM or PM"
    },
    "errors": {
      "outsideRange": "The time range must be between {min} and {max}.",
      "timeBeforeMin": "The time range must be start after {min}",
      "timeAfterMax": "The time range must be end before {max}",
      "endTimeAfterStartTime": "The end time must be after start time."
    }
  },
  "itemsPerPage": {
    "label": "Items per page",
    "select": {
      "listLabel": "Select number of items per page"
    }
  },
  "tableOfContents": {
    "label": "Table of contents"
  },
  "key": {
    "label": "\"{name}\" key"
  },
  "editor": {
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "strike": "Strike through",
    "alignments": {
      "left": "Left aligned",
      "center": "Centered",
      "right": "Right aligned",
      "block": "Block aligned"
    },
    "link": {
      "edit": "Edit link",
      "link": "Link",
      "text": "Text"
    },
    "quote": "Quote",
    "undo": "Undo",
    "redo": "Redo",
    "headings": {
      "headlines": "Headlines",
      "level": "Headline {n}",
      "paragraph": "Text"
    },
    "lists": {
      "lists": "Lists",
      "orderedList": "Numbered list",
      "unorderedList": "Bullet list"
    },
    "blockquote": "Blockquote"
  },
  "datePicker": {
    "popoverLabel": "Calendar"
  },
  "accordion": {
    "toggle": "Click to toggle content"
  }
}
